export default __webpack_public_path__ + "static/media/quimper.1970eeed.jpg";